import React from 'react';
import Section from './section';
import { Col, Row } from 'antd';
import styles from '../index.module.scss';
import BarChart from './barChart';
import LineChart from './lineChart';

interface iFleetOperationStatusProps {
    //总览数据
    overviewData?: {
        出行率?: number;
        单车日行驶里程?: number;
        环比?: number;
    };
    //图表数据
    chartsData?: {
        daily_vehicles?: any[];
        daily_mileage?: any[];
        daily_runtime?: any[];
        daily_speed?: any[];
    };
}

// 车队运行情况模块
const FleetOperationStatus = (props: iFleetOperationStatusProps) => {
    const { overviewData = {}, chartsData = {} } = props;

    // 格式化总览数据
    const formattedOverviewData = {
        vehicleOperationRate: overviewData.出行率 ? `${overviewData.出行率}%` : '暂无数据',
        singleVehicleDailyMileage: overviewData.单车日行驶里程 ? `${overviewData.单车日行驶里程}km` : '暂无数据',
        monthOnMonth: overviewData.环比 ? `${overviewData.环比 > 0 ? '+' : ''}${overviewData.环比}%` : '暂无数据'
    };

    // 转换图表数据格式
    const convertChartData = (data: any[] | undefined, name: string) => {
        if (!data || !Array.isArray(data)) return [];
        return [{
            name,
            value: data.map(item => {
                const value = item.count || item.mean || item.sum || item.max || item.vehicle_count || 0;
                // 如果是小数，保留两位小数
                const formattedValue = Number.isInteger(value) ? value : Number(value.toFixed(2));
                return [
                    item.day,
                    formattedValue
                ] as [string, number];
            })
        }];
    };

    // 日开行车辆数
    const dailyActiveVehicleCount = convertChartData(chartsData.daily_vehicles, '日开行车辆数');

    // 单车日均行驶里程
    const singleVehicleDailyMileage = convertChartData(chartsData.daily_mileage, '单车日均行驶里程');

    // 单车日运行时长
    const singleVehicleDailyOperationDuration = convertChartData(chartsData.daily_runtime, '单车日运行时长');

    // 单车日均行驶速度
    const singleVehicleDailyAverageSpeed = convertChartData(chartsData.daily_speed, '单车日均行驶速度');

    return (
        <Section title="五、车队运行情况">
            <div>
                <Row>
                    <Col span={4} className={`${styles.overviewTableLabel} ${styles.overviewTableCell}`}>车辆开行率</Col>
                    <Col span={4} className={`${styles.overviewTableValue} ${styles.overviewTableCell}`}>{formattedOverviewData.vehicleOperationRate}</Col>
                    <Col span={4} className={`${styles.overviewTableLabel} ${styles.overviewTableCell}`}>单车日行驶里程</Col>
                    <Col span={4} className={`${styles.overviewTableValue} ${styles.overviewTableCell}`}>{formattedOverviewData.singleVehicleDailyMileage}</Col>
                    <Col span={4} className={`${styles.overviewTableLabel} ${styles.overviewTableCell}`}>环比</Col>
                    <Col span={4} className={`${styles.overviewTableValue} ${styles.overviewTableCell}`}>{formattedOverviewData.monthOnMonth}</Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <BarChart data={dailyActiveVehicleCount} title="日开行车辆数" />
                    </Col>
                    <Col span={12}>
                        <BarChart data={singleVehicleDailyMileage} title="单车日均行驶里程" />
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <LineChart data={singleVehicleDailyOperationDuration} title="单车日运行时长" yAxisLabel="时长(小时)" />
                    </Col>
                    <Col span={12}>
                        <LineChart data={singleVehicleDailyAverageSpeed} title="单车日均行驶速度" yAxisLabel="速度(km/h)" />
                    </Col>
                </Row>
            </div>
        </Section>
    );
};

export default FleetOperationStatus;
